import * as AuditLogAction from "../actions/audit-log.action";

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Observable, map, switchMap } from "rxjs";

import { Injectable } from "@angular/core";
import { AuditLogService } from "@app/audit-log/services/audit-log.service";
import { DataActions } from "@app/project/store/actions";
import { Action } from "@ngrx/store";

@Injectable()
export class AuditLogEffects {
    constructor(private readonly actions$: Actions, private readonly auditDbService: AuditLogService) {}

    loadAuditType$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(AuditLogAction.loadType),
            switchMap(() =>
                DataActions.toAction2()(
                    this.auditDbService.fetchAuditLogTypes().pipe(map(auditlogTypes => ({ auditlogTypes }))),
                    AuditLogAction.loadTypeSuccess,
                    AuditLogAction.loadTypeFailure
                )
            )
        )
    );

    loadAuditLog$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(AuditLogAction.loadAuditLogSet.request),
            switchMap(({ params }) =>
                DataActions.toAction2()(
                    this.auditDbService.fetchAuditLogSet(params).pipe(map(auditLogs => ({ auditLogs }))),
                    AuditLogAction.loadAuditLogSet.success,
                    AuditLogAction.loadAuditLogSet.failure
                )
            )
        )
    );
}
